<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
    <PlusCircleIcon v-tooltip="'追加'" class="ml-auto mr-3 text-indigo-500 hover:text-indigo-700 active:text-indigo-600 cursor-pointer w-8 h-8" @click="edit(null)" />
    <div class="overflow-hidden rounded main-height">
      <div class="main-height overflow-auto">
        <table class="overflow-auto main table-auto mb-3">
          <thead class="main sticky top-0" style="background: white;">
            <tr>
              <th scope="col" class="px-2 py-3 text-center text-xs font-medium text-gray-500 tracking-wider">
                <input
                  type="search"
                  placeholder="得意先 検索"
                  class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:placeholder-gray-500 focus:text-gray-900" 
                  v-model="filter.client"
                  @change="getData()"
                />
              </th>
              <th scope="col" class="px-2 py-3 text-center text-xs font-medium text-gray-500 tracking-wider">
                <input
                  type="search"
                  placeholder="支店名 検索"
                  class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:placeholder-gray-500 focus:text-gray-900" 
                  v-model="filter.client2"
                  @change="getData()"
                />
              </th>
              <th scope="col" class="px-2 py-3 text-center text-xs font-medium text-gray-500 tracking-wider">
                <input
                  type="search"
                  placeholder="物件名 検索"
                  class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:placeholder-gray-500 focus:text-gray-900" 
                  v-model="filter.siteName"
                  @change="getData()"
                />
              </th>
              <th scope="col" class="px-2 py-3 text-center text-xs font-medium text-gray-500 tracking-wider">
                <input
                  type="search"
                  placeholder="お客様担当者 検索"
                  class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:placeholder-gray-500 focus:text-gray-900" 
                  v-model="filter.pic"
                  @change="getData()"
                />
              </th>
              <th scope="col" class="px-2 py-3 text-center text-xs font-medium text-gray-500 tracking-wider">
                <input
                  type="search"
                  placeholder="メアド 検索"
                  class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:placeholder-gray-500 focus:text-gray-900" 
                  v-model="filter.mail"
                  @change="getData()"
                />
              </th>
              <th></th>
              <th v-if="selectable"></th>
            </tr>
            <tr v-if="list && list.length" class="border border-gray-200 bg-colu">
              <th v-for="(c, index) in columns" :key="index" scope="col" class="px-2 py-3 text-xs font-medium text-gray-500 tracking-wider text-left">
                {{c.title}}
              </th>
              <th v-if="selectable"></th>
            </tr>
          </thead>

          <tr v-for="(row, i) in list" :key="i" class="border border-gray-200 tracking-wider hover:bg-teal-50">
            <!-- 得意先 -->
            <td class="px-2 py-3 whitespace-nowrap text-sm text-gray-700 min-300">
              {{ row.clientName }}<p class="text-xs text-gray-700">{{ row.clientCode }}</p>
            </td>
            <!-- 支店名 -->
            <td class="px-2 py-3 whitespace-nowrap text-sm text-gray-700 min-300">
              {{ row.clientName2 }}
            </td>
            <!-- 物件名 -->
            <td class="px-2 py-3 whitespace-nowrap text-sm text-gray-700 min-300">
              {{ row.siteName }}
            </td>
            <!-- お役様担当者名 -->
            <td class="px-2 py-3 whitespace-nowrap text-sm text-gray-700 min-300">
              {{ row.name }}
            </td>
            <!-- メール -->
            <td class="px-2 py-3 whitespace-nowrap text-sm text-gray-700 min-300">
              {{ row.mail }}
            </td>

            <td v-if="selectable" class="px-2 py-0.5">
              <PrimaryButton text="送信先に追加" size="xs" @click="$emit('closeClientModal', row)" />
            </td>

            <td class="px-2 py-0.5 text-center text-sm font-bold" @click="edit(row)" >
              <div class="text-blue-700 px-3 border-b border-blue-700 cursor-pointer w-fit">
                編集
              </div>
            </td>
          </tr>
        </table>

      </div>
      <div v-if="!list || !list.length" class="flex justify-center items-center text-gray-500 font-bold nothing">
        <p class="text-gray-400 font-bold">対象データがありません</p>
      </div>

      <!-- 編集画面 -->
      <ClientMailMstEditModal 
        v-model="editModalShow"
        :open="editModalShow"
        :target="editData"
        @close="closeModal"
      />
    </div>
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import ClientMailMstEditModal from '../components/ClientMailMstEditModal.vue'
import { PlusCircleIcon } from '@vue-hero-icons/solid'
import * as backend from '@libs/backend'
export default {
  components: {
      Modal,
      PrimaryButton,
      ClientMailMstEditModal,
      PlusCircleIcon
  },

  props: ['open', 'selectable'],

  data() {
    return {
      // カラム
      columns: [
          {title: '得意先'},
          {title: '支店名'},
          {title: '物件名など備考'},
          {title: 'お客様担当者'},
          {title: 'メールアドレス'},
          {title: ''},
      ],
      // リスト
      list: [],
      // 検索
      filter: {
        client: '',
        client2: '', // 支店名
        siteName: '',
        mail: '',
        pic: '', // お客様担当者
      },
      // 編集モーダル
      editModalShow: false,
      // 編集対象データ
      editData: []
    }
  },

  computed: {
  },

  watch: {
    open() {
      if (this.open) {
        this.getData()
      }
    }
  },

  methods: {
    async getData() {
      if (!this.open) {
        return
      }
      const res = await backend.searchData('mail/getData', { type: 1, ...this.filter })
      if (res.data.data) {
        this.list = res.data.data
      } else { 
        this.list = []
      }
    },

    /**
     * 編集ボタンイベント
     * @param row 編集対象データ
     */
    edit(row) {
      this.editData = null
      // 編集
      if (row) {
        this.editData = row
      }
      this.editModalShow = true
    },

    /**
     * 編集モーダルclode
     */
    closeModal() {
      this.editModalShow = false
      this.getData()
    },

    closed() {
      this.$emit('close')
      this.list = []
    }
  }
}
</script>
<style scoped>
.main-height {
  height: 85vh;
}

.main {
  min-width: 700px;
}

.min-300 {
  min-width: 300px;
}

.bg-colu {
  background: #ebfbec;
}

.nothing {
  position: absolute;
  top: 45%;
  left: 40%;
}

@media screen and (max-width: 1200px) {
  .main {
    overflow: auto;
  }
}
</style>